<template>
  <div class="text-center">
    <v-overlay
      :value="this.$store.state.ui.loader.iframe"
      :absolute="absolute"
      :z-index="zIndex"
    >
      <v-progress-circular
        indeterminate
        size="64"
      />
    </v-overlay>
  </div>
</template>

<script>
  export default {
    name: 'LoadingSpinner',
    data () {
      return {
        absolute: true,
        zIndex: 99,
      }
    },
  }
</script>
